export const StarFullIcon = ({ size = 25 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#a)'>
        <path
          d='M24.935 9.589a1.33 1.33 0 0 0-1.143-.913l-7.217-.655-2.852-6.677a1.329 1.329 0 0 0-2.445 0L8.426 8.02l-7.218.655A1.331 1.331 0 0 0 .453 11l5.455 4.784L4.3 22.869a1.329 1.329 0 0 0 1.977 1.437l6.223-3.721 6.222 3.72A1.328 1.328 0 0 0 20.7 22.87l-1.608-7.084L24.547 11c.4-.35.552-.905.388-1.412'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='a'>
          <path fill='#fff' d='M0 0h25v25H0z' />
        </clipPath>
      </defs>
    </svg>
  )
}
